class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.handleResize = this.onResize.bind(this);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));
    window.removeEventListener('resize', this.handleResize);
    if (!this.mainDetailsToggle.open) return;
    this.updateMenuPosition();
    window.addEventListener('resize', this.handleResize);
  }

  onResize() {
    if (!this.mainDetailsToggle.querySelector('summary').getClientRects().length) {
      this.close();
      return;
    }
    this.updateMenuPosition();
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.ceil(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
